module.exports = __webpack_public_path__ + "static/media/CTLA_9-286w.5300def7.jpg";